export const primaryColor = "#997404";
export const primaryColorOpacity = "rgba(251, 229, 132, 0.5)";
export const secondaryColor = "#614900";
export const customYellowColor = "#fbe584";
export const errorColor = "#dc3545";